<template>
    <!-- Same shape as bo-related-bundle-card, with the cart loading skeleton's shimmer. -->
    <div
        class="related-bundle-card related-bundle-card--skeleton"
        :class="`related-bundle-card--${variant}`"
        aria-hidden="true"
    >
        <div class="related-bundle-card__image cart-loading-placeholder__ghost"></div>
        <div class="related-bundle-card__details">
            <span class="related-bundle-card__ghost-line related-bundle-card__ghost-line--label cart-loading-placeholder__ghost"></span>
            <span class="related-bundle-card__ghost-line cart-loading-placeholder__ghost"></span>
            <span class="related-bundle-card__ghost-line related-bundle-card__ghost-line--price cart-loading-placeholder__ghost"></span>
        </div>
    </div>
</template>

<script>
// Placeholder for bo-related-bundle-card while the first page of related bundles loads.
export default {
    props: {
        // sidebar | row | grid | list, same as bo-related-bundle-card
        variant: {
            type: String,
            default: "sidebar",
        },
    },
};
</script>
